import { FormControl, FormGroup } from '@angular/forms';

export function validVesselInfo(control: FormGroup): { [key: string]: any } | null {
  const id = control.get('id');
  const name = control.get('name');

  if (name.value && !id.value) {
    id.setErrors({ 'required': true });
  }/* else {
    if (id.hasError('required')) {
      if (Object.keys(id.errors).length > 1) {
        id.setErrors({ 'required': null });
      } else {
        id.setErrors(null);
      }
    }
  }*/
  return null;
}

export function validateVesselId(c: FormControl) {
  let value: string;
  if (typeof c.value === 'undefined' || c.value === '') {
    return null;
  }
  if (typeof c.value === 'string') {
    value = c.value;
  } else if (typeof c.value === 'object' && c.value != null) {
    value = c.value.registrationNumber;
  } else {
    return null;
  }
  const format1 = /^([Hh][Aa])[-]?(\d{4})[-]?([A-Za-z]{1,2})?$/.test(value);
  const format2 = /(^\d{1,10}$)/.test(value);
  return format1 || format2 ? null : {
    validVesselId: {
      valid: false
    }
  };
}
